// extracted by mini-css-extract-plugin
module.exports = {"bg":"Home_bg__e4cBu","content":"Home_content__1SddX","sample":"Home_sample__3GVjb"};